// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Generator = require("../../builder/modules/Generator.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Generator_Markdown = require("../../builder/views/Generator_Markdown.bs.js");

var id = "minecraft-pig";

var name = "Minecraft Pig";

var history = [
  "Originally created by TepigMC.",
  "06 Feb 2015 lostminer: Add user variables.",
  "13 Feb 2015 lostminer: Update to use new version of generator.",
  "25 Feb 2015 TepigMC: Modified images; Fix drawing errors.",
  "26 Feb 2015 TepigMC: Removed missing texture checks; Rename files.",
  "27 Feb 2015 TepigMC: Compacted backgrounds and folds into sprite files.",
  "28 Feb 2015 TepigMC: Compacted labels and titles into sprite files; Added \"Advanced (Standard)\" head. Added \"Show Helmet Overlay\" option; Added texture options.",
  "09 Mar 2015 TepigMC: Fixed small bug with ultra mini pig."
];

var thumbnail = {
  url: require("./thumbnail/thumbnail-256.jpeg")
};

var instructions = "\n## About the Pig Generator\n\nThis generator creates a pig papercraft with an optional saddle,\nhelmet, and boots that can be removable. \n\nThere are also many customizable options to change the type of head,\nif the pig is wearing armor or if it is removable, etc. \n\nThere is also a bonus matching ultra mini pig that was inspired by \n[Maki](https://www.pixelpapercraft.com/user/maki)\n\n## Textures\n\nThe textures provided are:\n\n* Vanilla Minecraft\n* [Faithful 32x](http://www.minecraftforum.net/forums/mapping-and-modding/resource-packs/1223254-faithful-32x32-pack-update-red-cat-clay-1-8)\n* [Space Pig](http://www.planetminecraft.com/texture_pack/spacepig-space-apocalypse-16x-wip/)\n\n## Sizing\n\nThe saddle, helmet, and boots can vary in texture size,\nso the generator was made to be as general as possible.\n\nIf the helmet is covering the eyes or nose, then either\nmodify the texture file to make it fit better, or if it\nis separate after you print it you can trim off the parts\nthat cover the eyes or nose.\n";

var images = [];

var textures = [
  {
    id: "Background Sprites",
    url: require("./images/background-sprites.png"),
    standardWidth: 592,
    standardHeight: 608
  },
  {
    id: "Fold Sprites",
    url: require("./images/fold-sprites.png"),
    standardWidth: 600,
    standardHeight: 808
  },
  {
    id: "Label Sprites",
    url: require("./images/label-sprites.png"),
    standardWidth: 208,
    standardHeight: 80
  },
  {
    id: "Title Sprites",
    url: require("./images/title-sprites.png"),
    standardWidth: 294,
    standardHeight: 48
  },
  {
    id: "Pig (Vanilla)",
    url: require("./textures/vanilla/pig2.png"),
    standardWidth: 64,
    standardHeight: 32
  },
  {
    id: "Pig (Vanilla) (Programmer Art)",
    url: require("./textures/vanilla/pig.png"),
    standardWidth: 64,
    standardHeight: 32
  },
  {
    id: "Saddle (Vanilla)",
    url: require("./textures/vanilla/pig_saddle2.png"),
    standardWidth: 64,
    standardHeight: 32
  },
  {
    id: "Saddle (Vanilla) (Programmer Art)",
    url: require("./textures/vanilla/pig_saddle.png"),
    standardWidth: 64,
    standardHeight: 32
  },
  {
    id: "Diamond Armor (Vanilla)",
    url: require("./textures/vanilla/diamond-armor.png"),
    standardWidth: 64,
    standardHeight: 32
  },
  {
    id: "Gold Armor (Vanilla)",
    url: require("./textures/vanilla/gold-armor.png"),
    standardWidth: 64,
    standardHeight: 32
  },
  {
    id: "Chainmail Armor (Vanilla)",
    url: require("./textures/vanilla/chainmail-armor.png"),
    standardWidth: 64,
    standardHeight: 32
  },
  {
    id: "Iron Armor (Vanilla)",
    url: require("./textures/vanilla/iron-armor.png"),
    standardWidth: 64,
    standardHeight: 32
  },
  {
    id: "Pig (Faithful)",
    url: require("./textures/faithful/pig.png"),
    standardWidth: 64,
    standardHeight: 32
  },
  {
    id: "Saddle (Faithful)",
    url: require("./textures/faithful/saddle.png"),
    standardWidth: 64,
    standardHeight: 32
  },
  {
    id: "Diamond Armor (Faithful)",
    url: require("./textures/faithful/diamond-armor.png"),
    standardWidth: 64,
    standardHeight: 32
  },
  {
    id: "Gold Armor (Faithful)",
    url: require("./textures/faithful/gold-armor.png"),
    standardWidth: 64,
    standardHeight: 32
  },
  {
    id: "Chainmail Armor (Faithful)",
    url: require("./textures/faithful/chainmail-armor.png"),
    standardWidth: 64,
    standardHeight: 32
  },
  {
    id: "Iron Armor (Faithful)",
    url: require("./textures/faithful/iron-armor.png"),
    standardWidth: 64,
    standardHeight: 32
  },
  {
    id: "Pig (Space Pig)",
    url: require("./textures/space-pig/pig.png"),
    standardWidth: 64,
    standardHeight: 32
  },
  {
    id: "Saddle (Space Pig)",
    url: require("./textures/space-pig/saddle.png"),
    standardWidth: 64,
    standardHeight: 32
  },
  {
    id: "Armor (Space Pig)",
    url: require("./textures/space-pig/armor.png"),
    standardWidth: 64,
    standardHeight: 32
  },
  {
    id: "Skin",
    url: require("./textures/Steve.png"),
    standardWidth: 64,
    standardHeight: 64
  }
];

function script(param) {
  var pigTexture = "Pig";
  var saddleTexture = "Saddle";
  var armorTexture = "Armor (Layer 1)";
  var bgSprite = "Background Sprites";
  var foldSprite = "Fold Sprites";
  var labelSprite = "Label Sprites";
  var titleSprite = "Title Sprites";
  var makeTextureInput = function (texture, width, height, choices) {
    Generator.defineTextureInput(texture, {
          standardWidth: width,
          standardHeight: height,
          choices: choices
        });
  };
  makeTextureInput(pigTexture, 64, 32, [
        "Pig (Vanilla)",
        "Pig (Vanilla) (Programmer Art)",
        "Pig (Faithful)",
        "Pig (Space Pig)"
      ]);
  makeTextureInput(saddleTexture, 64, 32, [
        "Saddle (Vanilla)",
        "Saddle (Vanilla) (Programmer Art)",
        "Saddle (Faithful)",
        "Saddle (Space Pig)"
      ]);
  makeTextureInput(armorTexture, 64, 32, [
        "Diamond Armor (Vanilla)",
        "Gold Armor (Vanilla)",
        "Chainmail Armor (Vanilla)",
        "Iron Armor (Vanilla)",
        "Diamond Armor (Faithful)",
        "Gold Armor (Faithful)",
        "Chainmail Armor (Faithful)",
        "Iron Armor (Faithful)",
        "Armor (Space Pig)"
      ]);
  var drawSprite = function (sprite, spriteJson, x, y) {
    Generator.drawTextureLegacy(sprite, {
          x: spriteJson.x,
          y: spriteJson.y,
          w: spriteJson.w,
          h: spriteJson.h
        }, {
          x: x,
          y: y,
          w: spriteJson.w,
          h: spriteJson.h
        }, undefined, undefined, undefined, undefined);
  };
  Generator.defineBooleanInput("Show Folds", true);
  Generator.defineBooleanInput("Show Labels", true);
  Generator.defineBooleanInput("Show Titles", true);
  Generator.defineBooleanInput("Transparent Background", false);
  var showFolds = Generator.getBooleanInputValue("Show Folds");
  var showLabels = Generator.getBooleanInputValue("Show Labels");
  var showTitles = Generator.getBooleanInputValue("Show Titles");
  var hideHelmetOverlay = Generator.getBooleanInputValue("Hide Helmet Overlay");
  var isTransparent = Generator.getBooleanInputValue("Transparent Background");
  Generator.defineSelectInput("Nose Style", [
        "Flat",
        "3D"
      ]);
  Generator.defineSelectInput("Head Style", [
        "Simple",
        "Advanced",
        "Advanced (Standard)"
      ]);
  var noseStyle = Generator.getSelectInputValue("Nose Style");
  var headStyle = Generator.getSelectInputValue("Head Style");
  Generator.defineSelectInput("Saddle Style", [
        "Attached",
        "Separate"
      ]);
  Generator.defineSelectInput("Helmet Style", [
        "Attached",
        "Separate"
      ]);
  Generator.defineSelectInput("Boots Style", [
        "Attached",
        "Separate"
      ]);
  var saddleStyle = Generator.getSelectInputValue("Saddle Style");
  var helmetStyle = Generator.getSelectInputValue("Helmet Style");
  var bootsStyle = Generator.getSelectInputValue("Boots Style");
  Generator.defineBooleanInput("Show Ultra Mini", true);
  var showUltraMini = Generator.getBooleanInputValue("Show Ultra Mini");
  var useSaddle = saddleStyle !== "None";
  var useHelmet = helmetStyle !== "None";
  var useBoots = bootsStyle !== "None";
  var flatNose = noseStyle === "Flat";
  var simpleHead = headStyle === "Simple";
  var standardAdvancedHead = headStyle === "Advanced (Standard)";
  var separateSaddle = saddleStyle === "Separate";
  var separateHelmet = helmetStyle === "Separate";
  var separateBoots = bootsStyle === "Separate";
  var drawHeadAdvancedShape = function (texture, x, y, tx, ty) {
    Generator.drawTextureLegacy(texture, {
          x: tx,
          y: ty + 8 | 0,
          w: 8,
          h: 2
        }, {
          x: x,
          y: y + 64 | 0,
          w: 64,
          h: 16
        }, undefined, undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: tx + 2 | 0,
          y: ty + 10 | 0,
          w: 6,
          h: 6
        }, {
          x: x + 16 | 0,
          y: y + 80 | 0,
          w: 48,
          h: 48
        }, undefined, undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: tx + 8 | 0,
          y: ty + 8 | 0,
          w: 8,
          h: 8
        }, {
          x: x + 64 | 0,
          y: y + 64 | 0,
          w: 64,
          h: 64
        }, undefined, undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: tx + 16 | 0,
          y: ty + 8 | 0,
          w: 8,
          h: 2
        }, {
          x: x + 128 | 0,
          y: y + 64 | 0,
          w: 64,
          h: 16
        }, undefined, undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: tx + 16 | 0,
          y: ty + 10 | 0,
          w: 6,
          h: 6
        }, {
          x: x + 128 | 0,
          y: y + 80 | 0,
          w: 48,
          h: 48
        }, undefined, undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: tx + 8 | 0,
          y: ty,
          w: 8,
          h: 8
        }, {
          x: x + 64 | 0,
          y: y,
          w: 64,
          h: 64
        }, undefined, undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: tx + 16 | 0,
          y: ty,
          w: 8,
          h: 6
        }, {
          x: x + 64 | 0,
          y: y + 128 | 0,
          w: 64,
          h: 48
        }, undefined, undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: tx + 24 | 0,
          y: ty + 8 | 0,
          w: 8,
          h: 2
        }, {
          x: x + 192 | 0,
          y: y + 64 | 0,
          w: 64,
          h: 16
        }, undefined, undefined, undefined, undefined);
    if (!standardAdvancedHead) {
      Generator.drawTextureLegacy(texture, {
            x: tx + 24 | 0,
            y: ty + 10 | 0,
            w: 8,
            h: 6
          }, {
            x: x + 176 | 0,
            y: y + 80 | 0,
            w: 64,
            h: 48
          }, undefined, undefined, undefined, undefined);
      return Generator.drawTextureLegacy(texture, {
                  x: tx + 24 | 0,
                  y: ty + 10 | 0,
                  w: 8,
                  h: 2
                }, {
                  x: x,
                  y: y + 144 | 0,
                  w: 64,
                  h: 16
                }, undefined, 270.0, undefined, undefined);
    }
    
  };
  var drawHeadAdvanced = function (texture, x, y, isHelmet, drawLabels) {
    if (!isHelmet) {
      if (standardAdvancedHead) {
        drawSprite(bgSprite, {
              x: 312,
              y: 0,
              w: 280,
              h: 200
            }, x + 16 | 0, y);
      } else {
        drawSprite(bgSprite, {
              x: 0,
              y: 304,
              w: 296,
              h: 176
            }, x, y);
      }
    }
    drawHeadAdvancedShape(texture, x + 16 | 0, y, 0, 0);
    if (isHelmet && !hideHelmetOverlay) {
      drawHeadAdvancedShape(texture, x + 16 | 0, y, 32, 0);
    }
    if (standardAdvancedHead) {
      if (showFolds) {
        drawSprite(foldSprite, {
              x: 0,
              y: 304,
              w: 280,
              h: 200
            }, x + 16 | 0, y);
      }
      
    } else {
      drawSprite(foldSprite, {
            x: 304,
            y: 632,
            w: 296,
            h: 176
          }, x, y);
      if (showFolds) {
        drawSprite(foldSprite, {
              x: 0,
              y: 632,
              w: 296,
              h: 176
            }, x, y);
      }
      
    }
    if (drawLabels && showLabels) {
      if (standardAdvancedHead) {
        drawSprite(labelSprite, {
              x: 192,
              y: 0,
              w: 16,
              h: 48
            }, x + 16 | 0, y + 80 | 0);
        drawSprite(labelSprite, {
              x: 192,
              y: 0,
              w: 16,
              h: 48
            }, x + 192 | 0, y + 80 | 0);
      } else {
        drawSprite(labelSprite, {
              x: 64,
              y: 0,
              w: 64,
              h: 48
            }, x + 192 | 0, y + 80 | 0);
      }
      if (!flatNose) {
        drawSprite(labelSprite, {
              x: 128,
              y: 56,
              w: 32,
              h: 24
            }, x + 96 | 0, y + 96 | 0);
      }
      if (showTitles) {
        return drawSprite(titleSprite, {
                    x: 138,
                    y: 0,
                    w: 46,
                    h: 14
                  }, x + 22 | 0, y + 12 | 0);
      } else {
        return ;
      }
    }
    
  };
  var drawHeadSimpleShape = function (texture, x, y, textureOffsetX) {
    Generator.drawTextureLegacy(texture, {
          x: textureOffsetX,
          y: 8,
          w: 8,
          h: 8
        }, {
          x: x,
          y: y + 64 | 0,
          w: 64,
          h: 64
        }, undefined, undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: textureOffsetX + 8 | 0,
          y: 8,
          w: 8,
          h: 8
        }, {
          x: x + 64 | 0,
          y: y + 64 | 0,
          w: 64,
          h: 64
        }, undefined, undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: textureOffsetX + 16 | 0,
          y: 8,
          w: 8,
          h: 8
        }, {
          x: x + 128 | 0,
          y: y + 64 | 0,
          w: 64,
          h: 64
        }, undefined, undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: textureOffsetX + 24 | 0,
          y: 8,
          w: 8,
          h: 8
        }, {
          x: 256,
          y: y + 64 | 0,
          w: 64,
          h: 64
        }, undefined, undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: textureOffsetX + 8 | 0,
          y: 0,
          w: 8,
          h: 8
        }, {
          x: x + 64 | 0,
          y: y,
          w: 64,
          h: 64
        }, undefined, undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: textureOffsetX + 16 | 0,
          y: 0,
          w: 8,
          h: 8
        }, {
          x: x + 64 | 0,
          y: y + 128 | 0,
          w: 64,
          h: 64
        }, undefined, undefined, undefined, undefined);
  };
  var drawHeadSimple = function (texture, x, y, isHelmet, drawLabels) {
    if (!isHelmet) {
      drawSprite(bgSprite, {
            x: 312,
            y: 200,
            w: 280,
            h: 192
          }, x, y);
    }
    drawHeadSimpleShape(texture, x, y, 0);
    if (isHelmet && !hideHelmetOverlay) {
      drawHeadSimpleShape(texture, x, y, 32);
    }
    if (showFolds) {
      drawSprite(foldSprite, {
            x: 320,
            y: 256,
            w: 280,
            h: 192
          }, x, y);
    }
    if (drawLabels) {
      if (showLabels) {
        drawSprite(labelSprite, {
              x: 64,
              y: 0,
              w: 64,
              h: 48
            }, x + 192 | 0, y + 88 | 0);
        if (!flatNose) {
          drawSprite(labelSprite, {
                x: 128,
                y: 56,
                w: 32,
                h: 24
              }, x + 80 | 0, y + 96 | 0);
        }
        
      }
      if (showTitles) {
        return drawSprite(titleSprite, {
                    x: 138,
                    y: 0,
                    w: 46,
                    h: 14
                  }, x + 6 | 0, y + 12 | 0);
      } else {
        return ;
      }
    }
    
  };
  var drawNose3D = function (texture, x, y) {
    drawSprite(bgSprite, {
          x: 296,
          y: 392,
          w: 80,
          h: 80
        }, x, y);
    Generator.drawTextureLegacy(texture, {
          x: 16,
          y: 17,
          w: 1,
          h: 3
        }, {
          x: x + 16 | 0,
          y: y + 32 | 0,
          w: 8,
          h: 24
        }, undefined, undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: 17,
          y: 17,
          w: 4,
          h: 3
        }, {
          x: x + 24 | 0,
          y: y + 32 | 0,
          w: 32,
          h: 24
        }, undefined, undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: 21,
          y: 17,
          w: 1,
          h: 3
        }, {
          x: x + 56 | 0,
          y: y + 32 | 0,
          w: 8,
          h: 24
        }, undefined, undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: 10,
          y: 12,
          w: 4,
          h: 3
        }, {
          x: x + 24 | 0,
          y: y,
          w: 32,
          h: 24
        }, "Vertical", undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: 17,
          y: 16,
          w: 4,
          h: 1
        }, {
          x: x + 24 | 0,
          y: y + 24 | 0,
          w: 32,
          h: 8
        }, undefined, undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: 21,
          y: 16,
          w: 4,
          h: 1
        }, {
          x: x + 24 | 0,
          y: y + 56 | 0,
          w: 32,
          h: 8
        }, undefined, undefined, undefined, undefined);
    if (showFolds) {
      drawSprite(foldSprite, {
            x: 432,
            y: 552,
            w: 80,
            h: 80
          }, x, y);
    }
    if (showLabels) {
      drawSprite(labelSprite, {
            x: 160,
            y: 56,
            w: 32,
            h: 24
          }, x + 24 | 0, y);
    }
    if (showTitles) {
      return drawSprite(titleSprite, {
                  x: 244,
                  y: 0,
                  w: 46,
                  h: 14
                }, x + 68 | 0, y + 6 | 0);
    }
    
  };
  var drawNoseFlat = function (texture, x, y) {
    Generator.drawTextureLegacy(texture, {
          x: 17,
          y: 17,
          w: 4,
          h: 3
        }, {
          x: x + 80 | 0,
          y: y + 96 | 0,
          w: 32,
          h: 24
        }, undefined, undefined, undefined, undefined);
  };
  var drawBody = function (texture, x, y, isSaddle, drawLabels) {
    if (!isSaddle) {
      drawSprite(bgSprite, {
            x: 0,
            y: 0,
            w: 312,
            h: 304
          }, x, y);
    }
    Generator.drawTextureLegacy(texture, {
          x: 28,
          y: 16,
          w: 8,
          h: 16
        }, {
          x: x,
          y: y + 88 | 0,
          w: 64,
          h: 128
        }, undefined, undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: 36,
          y: 16,
          w: 10,
          h: 16
        }, {
          x: x + 64 | 0,
          y: y + 88 | 0,
          w: 80,
          h: 128
        }, undefined, undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: 46,
          y: 16,
          w: 8,
          h: 16
        }, {
          x: x + 144 | 0,
          y: y + 88 | 0,
          w: 64,
          h: 128
        }, undefined, undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: 54,
          y: 16,
          w: 10,
          h: 16
        }, {
          x: x + 208 | 0,
          y: y + 88 | 0,
          w: 80,
          h: 128
        }, undefined, undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: 36,
          y: 8,
          w: 10,
          h: 8
        }, {
          x: x + 64 | 0,
          y: y + 24 | 0,
          w: 80,
          h: 64
        }, undefined, undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: 46,
          y: 8,
          w: 10,
          h: 8
        }, {
          x: x + 64 | 0,
          y: y + 216 | 0,
          w: 80,
          h: 64
        }, "Vertical", undefined, undefined, undefined);
    if (showFolds) {
      drawSprite(foldSprite, {
            x: 0,
            y: 0,
            w: 312,
            h: 304
          }, x, y);
    }
    if (drawLabels) {
      if (showLabels) {
        drawSprite(labelSprite, {
              x: 0,
              y: 0,
              w: 64,
              h: 48
            }, x + 72 | 0, y + 24 | 0);
        drawSprite(labelSprite, {
              x: 128,
              y: 0,
              w: 32,
              h: 32
            }, x + 64 | 0, y + 96 | 0);
        drawSprite(labelSprite, {
              x: 160,
              y: 0,
              w: 32,
              h: 32
            }, x + 112 | 0, y + 96 | 0);
        drawSprite(labelSprite, {
              x: 128,
              y: 32,
              w: 32,
              h: 24
            }, x + 64 | 0, y + 192 | 0);
        drawSprite(labelSprite, {
              x: 160,
              y: 32,
              w: 32,
              h: 24
            }, x + 112 | 0, y + 192 | 0);
      }
      if (showTitles) {
        return drawSprite(titleSprite, {
                    x: 34,
                    y: 30,
                    w: 46,
                    h: 16
                  }, x + 6 | 0, y + 36 | 0);
      } else {
        return ;
      }
    }
    
  };
  var drawLeg = function (texture, x, y, labelID) {
    drawSprite(bgSprite, {
          x: 440,
          y: 392,
          w: 152,
          h: 160
        }, x, y);
    Generator.drawTextureLegacy(texture, {
          x: 0,
          y: 20,
          w: 4,
          h: 6
        }, {
          x: x,
          y: y + 56 | 0,
          w: 32,
          h: 48
        }, undefined, undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: 4,
          y: 20,
          w: 4,
          h: 6
        }, {
          x: x + 32 | 0,
          y: y + 56 | 0,
          w: 32,
          h: 48
        }, undefined, undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: 8,
          y: 20,
          w: 4,
          h: 6
        }, {
          x: x + 64 | 0,
          y: y + 56 | 0,
          w: 32,
          h: 48
        }, undefined, undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: 12,
          y: 20,
          w: 4,
          h: 6
        }, {
          x: x + 96 | 0,
          y: y + 56 | 0,
          w: 32,
          h: 48
        }, undefined, undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: 4,
          y: 16,
          w: 4,
          h: 4
        }, {
          x: x + 32 | 0,
          y: y + 24 | 0,
          w: 32,
          h: 32
        }, undefined, undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: 8,
          y: 16,
          w: 4,
          h: 4
        }, {
          x: x + 32 | 0,
          y: y + 104 | 0,
          w: 32,
          h: 32
        }, undefined, undefined, undefined, undefined);
    if (showFolds) {
      drawSprite(foldSprite, {
            x: 280,
            y: 448,
            w: 152,
            h: 160
          }, x, y);
    }
    var sprite = {
      x: 0,
      y: 0,
      w: 0,
      h: 0
    };
    if (labelID === 1) {
      sprite = {
        x: 0,
        y: 48,
        w: 32,
        h: 32
      };
    }
    if (labelID === 2) {
      sprite = {
        x: 32,
        y: 48,
        w: 32,
        h: 32
      };
    }
    if (labelID === 3) {
      sprite = {
        x: 64,
        y: 48,
        w: 32,
        h: 32
      };
    }
    if (labelID === 4) {
      sprite = {
        x: 96,
        y: 48,
        w: 32,
        h: 32
      };
    }
    if (showLabels) {
      drawSprite(labelSprite, sprite, x + 32 | 0, y + 24 | 0);
    }
    if (showTitles) {
      return drawSprite(titleSprite, {
                  x: 0,
                  y: 23,
                  w: 34,
                  h: 16
                }, x + 76 | 0, y + 4 | 0);
    }
    
  };
  var drawSaddleSeparate = function (texture, x, y) {
    Generator.drawTextureLegacy(texture, {
          x: 41,
          y: 16,
          w: 5,
          h: 16
        }, {
          x: x,
          y: y,
          w: 40,
          h: 128
        }, undefined, undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: 46,
          y: 16,
          w: 8,
          h: 16
        }, {
          x: x + 40 | 0,
          y: y,
          w: 64,
          h: 128
        }, undefined, undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: 54,
          y: 16,
          w: 10,
          h: 16
        }, {
          x: x + 104 | 0,
          y: y,
          w: 80,
          h: 128
        }, undefined, undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: 28,
          y: 16,
          w: 8,
          h: 16
        }, {
          x: x + 184 | 0,
          y: y,
          w: 64,
          h: 128
        }, undefined, undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: 41,
          y: 16,
          w: 5,
          h: 16
        }, {
          x: x + 248 | 0,
          y: y,
          w: 40,
          h: 128
        }, undefined, undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: 41,
          y: 16,
          w: 5,
          h: 16
        }, {
          x: x,
          y: y + 128 | 0,
          w: 40,
          h: 128
        }, "Vertical", undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: 46,
          y: 16,
          w: 8,
          h: 16
        }, {
          x: x + 40 | 0,
          y: y + 128 | 0,
          w: 64,
          h: 128
        }, "Vertical", undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: 54,
          y: 16,
          w: 10,
          h: 16
        }, {
          x: x + 104 | 0,
          y: y + 128 | 0,
          w: 80,
          h: 128
        }, "Vertical", undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: 28,
          y: 16,
          w: 8,
          h: 16
        }, {
          x: x + 184 | 0,
          y: y + 128 | 0,
          w: 64,
          h: 128
        }, "Vertical", undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: 41,
          y: 16,
          w: 5,
          h: 16
        }, {
          x: x + 248 | 0,
          y: y + 128 | 0,
          w: 40,
          h: 128
        }, "Vertical", undefined, undefined, undefined);
    if (showFolds) {
      drawSprite(foldSprite, {
            x: 312,
            y: 0,
            w: 288,
            h: 256
          }, x, y);
    }
    if (showTitles) {
      return drawSprite(titleSprite, {
                  x: 74,
                  y: 0,
                  w: 64,
                  h: 14
                }, x, y - 26 | 0);
    }
    
  };
  var drawHelmetSeparateShape = function (texture, x, y, tx, ty) {
    Generator.drawTextureLegacy(texture, {
          x: tx,
          y: ty + 8 | 0,
          w: 8,
          h: 3
        }, {
          x: x,
          y: y + 64 | 0,
          w: 64,
          h: 24
        }, undefined, undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: tx + 2 | 0,
          y: ty + 11 | 0,
          w: 6,
          h: 5
        }, {
          x: x + 16 | 0,
          y: y + 88 | 0,
          w: 48,
          h: 40
        }, undefined, undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: tx + 8 | 0,
          y: ty + 8 | 0,
          w: 8,
          h: 8
        }, {
          x: x + 64 | 0,
          y: y + 64 | 0,
          w: 64,
          h: 64
        }, undefined, undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: tx + 16 | 0,
          y: ty + 8 | 0,
          w: 8,
          h: 3
        }, {
          x: x + 128 | 0,
          y: y + 64 | 0,
          w: 64,
          h: 24
        }, undefined, undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: tx + 16 | 0,
          y: ty + 11 | 0,
          w: 6,
          h: 5
        }, {
          x: x + 128 | 0,
          y: y + 88 | 0,
          w: 48,
          h: 40
        }, undefined, undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: tx + 24 | 0,
          y: ty + 8 | 0,
          w: 8,
          h: 3
        }, {
          x: x + 192 | 0,
          y: y + 64 | 0,
          w: 64,
          h: 24
        }, undefined, undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: tx + 8 | 0,
          y: ty,
          w: 8,
          h: 8
        }, {
          x: x + 64 | 0,
          y: y,
          w: 64,
          h: 64
        }, undefined, undefined, undefined, undefined);
  };
  var drawHelmetSeparate = function (texture, x, y) {
    drawSprite(bgSprite, {
          x: 0,
          y: 480,
          w: 280,
          h: 128
        }, x, y);
    drawHelmetSeparateShape(texture, x, y, 0, 0);
    if (!hideHelmetOverlay) {
      drawHelmetSeparateShape(texture, x, y, 32, 0);
    }
    if (showFolds) {
      drawSprite(foldSprite, {
            x: 0,
            y: 504,
            w: 280,
            h: 128
          }, x, y);
    }
    if (showTitles) {
      return drawSprite(titleSprite, {
                  x: 184,
                  y: 0,
                  w: 60,
                  h: 14
                }, x - 8 | 0, y + 12 | 0);
    }
    
  };
  var drawBoot = function (texture, x, y, separate) {
    if (separate) {
      drawSprite(bgSprite, {
            x: 280,
            y: 504,
            w: 152,
            h: 104
          }, x, y);
    }
    Generator.drawTextureLegacy(texture, {
          x: 0,
          y: 26,
          w: 4,
          h: 6
        }, {
          x: x,
          y: y + 0 | 0,
          w: 32,
          h: 48
        }, undefined, undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: 4,
          y: 26,
          w: 4,
          h: 6
        }, {
          x: x + 32 | 0,
          y: y + 0 | 0,
          w: 32,
          h: 48
        }, undefined, undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: 8,
          y: 26,
          w: 4,
          h: 6
        }, {
          x: x + 64 | 0,
          y: y + 0 | 0,
          w: 32,
          h: 48
        }, undefined, undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: 12,
          y: 26,
          w: 4,
          h: 6
        }, {
          x: x + 96 | 0,
          y: y + 0 | 0,
          w: 32,
          h: 48
        }, undefined, undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: 8,
          y: 16,
          w: 4,
          h: 4
        }, {
          x: x + 32 | 0,
          y: y + 48 | 0,
          w: 32,
          h: 32
        }, undefined, undefined, undefined, undefined);
    if (showFolds) {
      drawSprite(foldSprite, {
            x: 448,
            y: 448,
            w: 152,
            h: 104
          }, x, y);
    }
    if (separate && showTitles) {
      return drawSprite(titleSprite, {
                  x: 44,
                  y: 16,
                  w: 42,
                  h: 14
                }, x, y - 26 | 0);
    }
    
  };
  var drawUltraMiniBody = function (texture, x, y) {
    Generator.drawTextureLegacy(texture, {
          x: 28,
          y: 16,
          w: 8,
          h: 16
        }, {
          x: x + 8 | 0,
          y: y + 20 | 0,
          w: 8,
          h: 12
        }, undefined, 180.0, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: 36,
          y: 16,
          w: 10,
          h: 16
        }, {
          x: x + 32 | 0,
          y: y + 20 | 0,
          w: 8,
          h: 12
        }, undefined, 180.0, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: 46,
          y: 16,
          w: 8,
          h: 16
        }, {
          x: x + 24 | 0,
          y: y + 20 | 0,
          w: 8,
          h: 12
        }, undefined, 180.0, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: 54,
          y: 16,
          w: 10,
          h: 16
        }, {
          x: x + 16 | 0,
          y: y + 20 | 0,
          w: 8,
          h: 12
        }, undefined, 180.0, undefined, undefined);
  };
  var drawUltraMiniLegs = function (texture, x, y) {
    Generator.drawTextureLegacy(texture, {
          x: 8,
          y: 16,
          w: 4,
          h: 4
        }, {
          x: x + 24 | 0,
          y: y + 8 | 0,
          w: 3,
          h: 3
        }, "Vertical", undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: 8,
          y: 16,
          w: 4,
          h: 4
        }, {
          x: x + 29 | 0,
          y: y + 8 | 0,
          w: 3,
          h: 3
        }, "Vertical", undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: 8,
          y: 16,
          w: 4,
          h: 4
        }, {
          x: x + 24 | 0,
          y: y + 17 | 0,
          w: 3,
          h: 3
        }, "Vertical", undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: 8,
          y: 16,
          w: 4,
          h: 4
        }, {
          x: x + 29 | 0,
          y: y + 17 | 0,
          w: 3,
          h: 3
        }, "Vertical", undefined, undefined, undefined);
  };
  var drawUltraMiniEnds = function (texture, x, y) {
    Generator.drawTextureLegacy(texture, {
          x: 8,
          y: 8,
          w: 8,
          h: 8
        }, {
          x: x + 8 | 0,
          y: y + 20 | 0,
          w: 8,
          h: 8
        }, undefined, undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: 17,
          y: 17,
          w: 4,
          h: 3
        }, {
          x: x + 10 | 0,
          y: y + 24 | 0,
          w: 4,
          h: 3
        }, undefined, undefined, undefined, undefined);
    Generator.drawTextureLegacy(texture, {
          x: 46,
          y: 8,
          w: 10,
          h: 8
        }, {
          x: x + 8 | 0,
          y: y,
          w: 8,
          h: 8
        }, "Vertical", undefined, undefined, undefined);
  };
  var drawUltraMiniHelmet = function (texture, x, y) {
    Generator.drawTextureLegacy(texture, {
          x: 8,
          y: 8,
          w: 8,
          h: 8
        }, {
          x: x + 8 | 0,
          y: y + 20 | 0,
          w: 8,
          h: 8
        }, undefined, undefined, undefined, undefined);
    if (!hideHelmetOverlay) {
      return Generator.drawTextureLegacy(texture, {
                  x: 40,
                  y: 8,
                  w: 8,
                  h: 8
                }, {
                  x: x + 8 | 0,
                  y: y + 20 | 0,
                  w: 8,
                  h: 8
                }, undefined, undefined, undefined, undefined);
    }
    
  };
  var drawUltraMini = function (x, y) {
    drawSprite(bgSprite, {
          x: 328,
          y: 472,
          w: 36,
          h: 28
        }, x, y);
    drawUltraMiniBody(pigTexture, x, y);
    drawUltraMiniLegs(pigTexture, x, y);
    drawUltraMiniEnds(pigTexture, x, y);
    if (useSaddle) {
      drawUltraMiniBody(saddleTexture, x, y);
    }
    if (useHelmet) {
      drawUltraMiniHelmet(armorTexture, x, y);
    }
    if (useBoots) {
      drawUltraMiniLegs(armorTexture, x, y);
    }
    if (showTitles) {
      return drawSprite(titleSprite, {
                  x: 0,
                  y: 16,
                  w: 44,
                  h: 7
                }, x - 8 | 0, y - 15 | 0);
    }
    
  };
  var drawCredits = function (param) {
    drawSprite(titleSprite, {
          x: 0,
          y: 0,
          w: 74,
          h: 16
        }, 19, 805);
    drawSprite(titleSprite, {
          x: 86,
          y: 14,
          w: 208,
          h: 34
        }, 368, 788);
  };
  var drawOpaque = function (param) {
    if (!isTransparent) {
      var spriteJson = {
        x: 296,
        y: 472,
        w: 32,
        h: 32
      };
      var x = 0;
      var y = 0;
      var width = 595;
      var height = 842;
      return Generator.drawTextureLegacy(bgSprite, {
                  x: spriteJson.x,
                  y: spriteJson.y,
                  w: spriteJson.w,
                  h: spriteJson.h
                }, {
                  x: x,
                  y: y,
                  w: width,
                  h: height
                }, undefined, undefined, undefined, undefined);
    }
    
  };
  Generator.usePage("Pig");
  drawOpaque(undefined);
  drawCredits(undefined);
  if (simpleHead) {
    drawHeadSimple(pigTexture, 64, 96, false, !useHelmet || separateHelmet);
  } else {
    drawHeadAdvanced(pigTexture, 48, 96, false, !useHelmet || separateHelmet);
  }
  drawBody(pigTexture, 56, 304, false, !useSaddle || separateSaddle);
  drawLeg(pigTexture, 392, 104, 1);
  drawLeg(pigTexture, 392, 288, 2);
  drawLeg(pigTexture, 392, 472, 3);
  drawLeg(pigTexture, 240, 584, 4);
  if (flatNose) {
    drawNoseFlat(pigTexture, 64, 96);
  } else {
    drawNose3D(pigTexture, 248, 272);
  }
  if (useHelmet && !separateHelmet) {
    Generator.defineRegionInput([
          64,
          96,
          256,
          192
        ], (function (param) {
            Generator.setBooleanInputValue("Hide Helmet Overlay", !hideHelmetOverlay);
          }));
    if (simpleHead) {
      drawHeadSimple(armorTexture, 64, 96, true, true);
    } else {
      drawHeadAdvanced(armorTexture, 48, 96, true, true);
    }
  }
  if (useSaddle && !separateSaddle) {
    drawBody(saddleTexture, 56, 304, true, true);
  }
  if (useBoots && !separateBoots) {
    drawBoot(armorTexture, 392, 160, false);
    drawBoot(armorTexture, 392, 344, false);
    drawBoot(armorTexture, 392, 528, false);
    drawBoot(armorTexture, 240, 640, false);
  }
  if (showUltraMini) {
    drawUltraMini(120, 650);
  }
  if (useSaddle && separateSaddle || useHelmet && separateHelmet || useBoots && separateBoots) {
    Generator.usePage("Accessories");
    drawOpaque(undefined);
    drawCredits(undefined);
    if (useSaddle && separateSaddle) {
      drawSaddleSeparate(saddleTexture, 56, 328);
    }
    if (useHelmet && separateHelmet) {
      Generator.defineRegionInput([
            64,
            96,
            256,
            192
          ], (function (param) {
              Generator.setBooleanInputValue("Hide Helmet Overlay", !hideHelmetOverlay);
            }));
      drawHelmetSeparate(armorTexture, 64, 96);
    }
    if (useBoots && separateBoots) {
      drawBoot(armorTexture, 392, 160, true);
      drawBoot(armorTexture, 392, 344, true);
      drawBoot(armorTexture, 392, 528, true);
      return drawBoot(armorTexture, 240, 640, true);
    } else {
      return ;
    }
  }
  
}

var generator_thumbnail = thumbnail;

var generator_instructions = Caml_option.some(React.createElement(Generator_Markdown.make, {
          children: instructions
        }));

var generator = {
  id: id,
  name: name,
  history: history,
  thumbnail: generator_thumbnail,
  video: undefined,
  instructions: generator_instructions,
  images: images,
  textures: textures,
  script: script
};

var Builder;

exports.Builder = Builder;
exports.id = id;
exports.name = name;
exports.history = history;
exports.thumbnail = thumbnail;
exports.instructions = instructions;
exports.images = images;
exports.textures = textures;
exports.script = script;
exports.generator = generator;
/* thumbnail Not a pure module */
